import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { AuthEntryCard } from '@/features/auth/components/AuthEntryCard'
import { AuthInstructionList } from '@/features/auth/components/AuthInstructionList'
import { BiometricPreview } from '@/features/auth/components/BiometricPreview'
import { Button } from '@/shared/components/ui/Button'
import {
  getRegistrationState,
  resetRegistration,
  setFlowStep,
} from '@/features/auth/store/registration.store'

export function AuthBiometricIntroPage() {
  const navigate = useNavigate()
  const { t } = useTranslation('register')
  const { biometricToken, biometricCompleted } = getRegistrationState()

  const instructionItems = [
    t('register:biometricIntro.instruction1'),
    t('register:biometricIntro.instruction2'),
    t('register:biometricIntro.instruction3'),
    t('register:biometricIntro.instruction4'),
  ]

  useEffect(() => {
    if (biometricCompleted) {
      resetRegistration()
      setFlowStep('consent')
      navigate('/register/consent', { replace: true })
      return
    }
    if (!biometricToken) {
      navigate('/register/identity', { replace: true })
      return
    }
    setFlowStep('biometric')
  }, [biometricCompleted, biometricToken, navigate])

  if (biometricCompleted || !biometricToken) return null

  return (
    <AuthEntryCard
      variant="biometric"
      contentClassName="text-center"
    >
      <section className="mt-4 w-full max-w-96 text-center">
        <h1 className="m-0 text-xl leading-tight font-bold text-text-primary">{t('register:biometricIntro.title')}</h1>
        <p className="mt-3 text-sm leading-6 text-text-muted">
          {t('register:biometricIntro.description')}
        </p>
      </section>

      <div className="mt-8 w-full max-w-[32rem]">
        <AuthInstructionList items={instructionItems} />
      </div>

      <div className="mt-8">
        <BiometricPreview isReady size="compact" />
      </div>

      <div className="mt-8 flex w-full max-w-96 justify-center">
        <Button className="min-h-9 px-5 py-1.5 text-sm" onClick={() => navigate('/register/permissions', { replace: true })}>
          {t('register:biometricIntro.btn.start')}
        </Button>
      </div>
    </AuthEntryCard>
  )
}
